import { NgModule } from '@angular/core';
// import { GplinkComponent } from './gplink.component';
import { GplinkPipe } from './gplink.pipe';

@NgModule({
  declarations: [ GplinkPipe],
  imports: [
  ],
  exports: [GplinkPipe]
})
export class GplinkModule { }
